/**
 * Lightweight haptic feedback helper.
 * Uses navigator.vibrate (Android Chrome, most mobile browsers).
 * iOS Safari doesn't support vibrate — fails silently.
 *
 * Usage:
 *   import { haptic } from "@/lib/haptics";
 *   haptic("light"); // tap / nav
 *   haptic("medium"); // confirm / submit
 *   haptic("success"); // positive action completed
 *   haptic("warning"); // destructive action
 */
const PATTERNS = {
  light: 10,
  medium: 18,
  heavy: 28,
  success: [12, 40, 18],
  warning: [20, 60, 20, 60, 20],
};

export function haptic(kind = "light") {
  if (typeof navigator === "undefined" || !navigator.vibrate) return;
  try {
    navigator.vibrate(PATTERNS[kind] ?? PATTERNS.light);
  } catch {
    /* noop */
  }
}
